export enum PaginationNumEnum {
  ZERO = 0,
  ONE = 1,
}
